import { type CaraWorkspaceEffortLevel } from '~/api/graphql';
import { resolveEffortLevel, useEffortLevelChoices } from '~/components/presets/effort-level';
import { type RunCardState } from './run-card-submission';

/**
 * The effort a run card submits. With the effort selector on, `choices` is what
 * it offers and `effortLevel` is always set, Auto included; with it off,
 * `effortLevel` is unset so the server applies its default.
 */
export const useEffortLevel = (
  state: RunCardState
): {
  effortLevel: CaraWorkspaceEffortLevel | undefined;
  selectorEnabled: boolean;
  choices: ReturnType<typeof useEffortLevelChoices>['choices'];
} => {
  const { enabled, choices } = useEffortLevelChoices();
  return {
    effortLevel: enabled ? resolveEffortLevel(state.effortLevel, choices) : undefined,
    selectorEnabled: enabled,
    choices
  };
};
